/**************************************************
 * Nombre:       Dialogo_Usuario_Padres
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Usuario_Padres from "../Formularios/Formulario_Usuario_Padres";
import {correoAId} from "../../CodNegocio/Funciones/correoAId";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {actualizarDoc} from "../../Servicios/BD/actualizarDoc";
import {adap_cuenta_hijo} from "../../CodNegocio/Adaptadores/adap_cuenta_hijo";

const Dialogo_Usuario_Padres = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')
        let padres = entidad.padres
        for (let i = 0; i < padres.length; i++) {
            let padre = padres[i]
            let doxEquipoPadre = await obtenerDoc('equipos', correoAId(padre))
            if (doxEquipoPadre.res) {

                let equipoPadre = doxEquipoPadre.data;
                let nivelConseguir = equipoPadre[JSON.stringify(i)]
               // console.log(nivelConseguir)
                let index = nivelConseguir.findIndex((e) => e.idUsuario === entidad.id)
                if (index === -1) {
                    let arr = nivelConseguir
                    arr.push(adap_cuenta_hijo(entidad))
                    await agrearHijoANivel(correoAId(padre), JSON.stringify(i), arr)
                }

            }
        }


        let arr = []
        for (let i = 0; i < padres.length; i++) {
            let padre = padres[i]
            arr.push(correoAId(padre))
        }
        entidad.padres = arr

        await guardarDoc('cuentas', entidad)

        let dox = await guardarDoc('cuentas', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const agrearHijoANivel = async (idPadre, nivel, arr) => {

        await actualizarDoc('equipos', idPadre, {[nivel]: arr})

    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Usuario_Padres props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Usuario_Padres